/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPermissionsResponse } from '../../models/get-permissions-response';
import { PermissionTypeEnum } from '../../models/permission-type-enum';

export interface GetMenuSectionPermissions$Params {

/**
 * ID sekcie
 */
  id: number;

/**
 * typ oprávnenia (PRODUCT/COMPANY)
 */
  permissionType?: PermissionTypeEnum;
}

export function getMenuSectionPermissions(http: HttpClient, rootUrl: string, params: GetMenuSectionPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getMenuSectionPermissions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('permissionType', params.permissionType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPermissionsResponse>;
    })
  );
}

getMenuSectionPermissions.PATH = '/admin/menu/{id}/permissions';
